/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ubtButtonNew, ubtModuleExposeNew } from '@/shared/utils/ubt';

// 分期商城协议页
const shopMallAgreementPageId = 'finance_loan_shopMall_agreement';

export function newUbtPageButton(
  buttonName: string,
  otherProps?: Dictionary,
): void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const pageId = shopMallAgreementPageId;
  ubtButtonNew(
    pageId,
    buttonName,
    otherProps,
  );
}

export function newUbtModuleExpose(
  buttonName: string,
  otherProps?: Dictionary,
):void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const pageId = shopMallAgreementPageId;
  ubtModuleExposeNew(
    pageId,
    buttonName,
    otherProps,
  );
}

/** 臻有钱-分期商城协议页-曝光 - expose */
export const shopMallAgreementExpose = 'finance_loan_shopMall_agreement_expose';

/** 臻有钱-分期商城协议页-点击 - click */
export const shopMallAgreementClick = 'finance_loan_shopMall_agreement_click';

/** 臻有钱-分期商城协议页-挽留弹窗曝光 - expose */
export const retentionDialogExpose = 'finance_loan_shopMall_agreement_dialog_expose';

/** 臻有钱-分期商城协议页-挽留弹窗确认按钮点击 - click */
export const retentionDialogConfirmClick = 'finance_loan_shopMall_agreement_dialog_confirm_click';
